import { SuggestionModel } from "core-library/components/smart-suggest/suggestion.model";

export class SmartSuggestService {
    public static getSuggestionElements(suggestions: Array<SuggestionModel>, title: string): Array<string>{
        const elements = new Array<string>();
        if (!suggestions.length) {
            return elements;
        }

        elements.push(`<h2 class="pcg-smart-search__category pcg-contrast__bg-alt">${title}</h2>`);

        suggestions.forEach(x => elements.push(`
            <a href="${x.url}" class="pcg-smart-search__link pcg-contrast__border-main">
                <span class="pcg-smart-search__title pcg-contrast__link">${x.name}</span>
            </a>`));

        return elements;
    }

    public static getShowMoreElement(showMoreCount: number, searchText: string, searchPageUrl: string): string {
        if (showMoreCount <= 0) {
            return "";
        }

        return `
            <div class="pcg-smart-search__link pcg-contrast__border-main">
                <span class="pcg-smart-search__title pcg-contrast__color-main">${showMoreCount} more...</span>
                <a href="${searchPageUrl}?searchText=${searchText}" class="pcg-smart-search__content pcg-contrast__link">Click here to search all results</a>
            </div>
        `;
    }
}
